import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { accountNumber, password, username } from '../internal.js'

const credentialTypes = [username, password] as const
const locationCredentialTypes = [accountNumber] as const

export type dafgCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const dafgDocumentTypes = [
  'customs-documents',
  'dimension-certificate',
  'invoice',
  'nmfc-certificate',
  'proof-of-delivery',
  'signed-bol',
  'weight-cert',
] as const satisfies readonly DocumentType[]

export const dafg: CarrierDef<dafgCredType> = {
  name: 'Dayton Freight Lines',
  scac: 'dafg',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    {
      id: 'guaranteed_five_pm',
      name: 'Guaranteed by 5pm',
      guaranteed: true,
      guaranteedByTime: '17:00',
    },
    {
      id: 'guaranteed_twelve_pm',
      name: 'Guaranteed by Noon',
      guaranteed: true,
      guaranteedByTime: '12:00',
    },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ['username', 'username'], // engine only
    ['password', 'password'], // engine only
    ['account-number', 'ref1'],
  ],
  engineLayers: [
    'rating',
    'bol',
    'pickup',
    'cancel',
    'tracking',
    'profinder',
    'documents',
  ],
  documentTypes: dafgDocumentTypes,
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
